import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRouteVendeur = () => {
  const vendeur = JSON.parse(localStorage.getItem('vendeurConnecte'));

  return vendeur ? <Outlet /> : <Navigate to="/vendeur/login" />;
};

export default PrivateRouteVendeur;